import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import profileSlice from '../pages/profile/slide';
import restaurantSlice from '../pages/restaurant/slice';
import messageSlice from './messageSlice';
import authenInfoSlice from './authenInfoSlice';
import orderSlice from '../pages/orders/store.orders';
import countSlice from './countSlice';

const makeStore = () => {
  const store = configureStore({
    reducer: {
      [messageSlice.name]: messageSlice.reducer,
      [profileSlice.name]: profileSlice.reducer,
      [restaurantSlice.name]: restaurantSlice.reducer,
      [orderSlice.name]: orderSlice.reducer,
      [authenInfoSlice.name]: authenInfoSlice.reducer,
      [countSlice.name]: countSlice.reducer,
    },
  });

  return store;
};
const store = makeStore();

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;

export default store;
